// extracted by mini-css-extract-plugin
export default {"content":"ZynQPh","title":"fvAz3b","description":"HXhEf1","descriptionLink":"Wa8aVv"};